import { ThemeEvents } from '@theme/events';

class ProductSku extends HTMLElement {
  connectedCallback() {
    this.#listenerTarget = this.closest('.shopify-section, dialog');
    this.#listenerTarget?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    this.#listenerTarget?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  #handleVariantUpdate = (event) => {
    const { detail } = event;
    if (!detail?.data) return;

    if (detail.data.newProduct) {
      this.dataset.productId = detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    this.#updateSku(detail.resource);
  };

  #updateSku(variant) {
    const valueTarget = this.querySelector('[data-sku-value]');
    if (!valueTarget) return;

    const sku = typeof variant?.sku === 'string' ? variant.sku.trim() : '';
    const showWhenBlank = this.dataset.showWhenBlank === 'true';
    const fallbackText = this.dataset.fallbackText || '';

    if (sku) {
      valueTarget.textContent = sku;
      valueTarget.removeAttribute('aria-hidden');
      this.removeAttribute('hidden');
      this.dataset.empty = 'false';
      return;
    }

    this.dataset.empty = 'true';

    if (showWhenBlank) {
      valueTarget.textContent = fallbackText;
      valueTarget.toggleAttribute('aria-hidden', fallbackText === '');
      this.removeAttribute('hidden');
      return;
    }

    valueTarget.textContent = '';
    valueTarget.setAttribute('aria-hidden', 'true');
    this.setAttribute('hidden', 'true');
  }

  #listenerTarget;
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}

